import { useEffect, useState } from 'react';

import type { User } from '@auth0/auth0-spa-js';

import { getUser } from '@platform/core/auth';

export const useGetUserInfo = () => {
  const [user, setUser] = useState<User | undefined>();

  useEffect(() => {
    const fetchUser = async () => {
      const authUser = await getUser();
      setUser(authUser);
    };
    fetchUser();
  }, []);

  return user;
};
